// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"827a51a8","410":"b2843d81","412":"44fa0e18","453":"472ac091","484":"b2835caa","498":"75532a20","508":"1b2fd427","551":"bd0b2313","572":"8ff70d16","616":"87c54ada","815":"666005d0","869":"32676d73","974":"e009b244"}[chunkId] + ".chunk.js";
};